import React from 'react';
import { FormattedMessage } from 'react-intl';
import Config from '../../config';
import { Link, Line } from '../../pages/SignUp/styles';
import Constants from '../../shared/constants';
import { getLocaleFromURL } from '../../shared/utils';

const currentLanguage = getLocaleFromURL() || Config.language;
const TermsAndConditions = ({ color }) => (
  <Link
    href={`${Config.wordpressUrl}/${currentLanguage}/${Constants.wpURL[currentLanguage].termsAndConditions}`}
    color={color}
  >
    <Line>
      <FormattedMessage id="common_terms_and_conditions" />
    </Line>
  </Link>
);
export default TermsAndConditions;
